import { makeStyles } from '@material-ui/core/styles';
import { TextColors, SecondaryColors, TextOpacities, colorMap } from '@/utils/constants';
import { hexToRGBA } from '@/utils/helpers';

const cardMobileSidePadding = 2;
const linearGradients = {
  '&.card-color-white:after': {
    background: `linear-gradient(to top, ${colorMap.white}, ${hexToRGBA(colorMap.white, 0)})`,
  },
  '&.card-color-eggshell:after': {
    background: `linear-gradient(to top, ${colorMap.eggshell}, ${hexToRGBA(colorMap.eggshell, 0)})`,
  },
  '&.card-color-charcoal:after': {
    background: `linear-gradient(to top, ${colorMap.charcoal}, ${hexToRGBA(colorMap.charcoal, 0)})`,
  },
  '&.card-color-medium-gray:after': {
    background: `linear-gradient(to top, ${colorMap['medium-gray']}, ${hexToRGBA(
      colorMap['medium-gray'],
      0,
    )})`,
  },
  '&.card-color-dark-gray:after': {
    background: `linear-gradient(to top, ${colorMap['dark-gray']}, ${hexToRGBA(
      colorMap['dark-gray'],
      0,
    )})`,
  },
  '&.card-color-black:after': {
    background: `linear-gradient(to top, ${colorMap.black}, ${hexToRGBA(colorMap.black, 0)})`,
  },
};

const darkTheme = {
  root: {
    '&.MuiPaper-root': {
      color: TextColors.light,
    },

    '& $contentHeading': {
      color: TextColors.light,
    },

    '& $copy': {
      '& *': {
        color: hexToRGBA(TextColors.light, TextOpacities.dark2),
      },
    },

    '& $contentCategory': {
      color: SecondaryColors.main,
    },
  },
};

const lightTheme = {
  root: {
    '&.MuiPaper-root': {
      color: TextColors.dark,
    },

    '& $contentHeading': {
      color: TextColors.dark,
    },

    '& $copy': {
      '& *': {
        color: hexToRGBA(TextColors.dark, TextOpacities.light2),
      },
    },

    '& $contentCategory': {
      color: SecondaryColors.dark,
    },
  },
};

const useStyles = makeStyles(
  (muiTheme) => ({
    root: {
      '&.dark-theme': darkTheme.root,
      '&.light-theme': lightTheme.root,

      height: '100%',
      overflow: 'hidden',
      width: '100%',
      display: 'flex',
      flexFlow: 'column nowrap',
      alignContent: 'space-between',
      alignItems: 'space-between',
      position: 'relative',

      '& .card-content': {
        transition: 'all 250ms ease-in-out',
      },

      '&:hover': {
        '& .card-content': {
          top: '0 !important',
        },
      },
    },

    avatar: {
      [muiTheme.breakpoints.up('md')]: {
        marginTop: muiTheme.spacing(1),
      },
    },
    bottom: {},
    heading: {},

    carousel: {
      height: '100%',
    },

    swiper: {
      height: '100%',

      '& .swiper-container': {
        height: '100%',
      },
    },

    content: {
      '&.MuiCardContent-root': {
        position: 'absolute',
        left: 0,
        right: 0,
        bottom: 0,
        overflow: 'hidden',
        padding: muiTheme.spacing(2, cardMobileSidePadding),
        zIndex: 1,
        textAlign: 'left',

        [muiTheme.breakpoints.up('md')]: {
          padding: muiTheme.spacing(2.25),

          '&:last-child': {
            paddingBottom: muiTheme.spacing(2.25),
          },
        },
      },
    },

    contentHeading: {
      '&.MuiTypography-root': {
        transition: 'opacity 50ms ease-in, visibility 50ms ease-in',
        zIndex: 1,
        position: 'relative',
      },
    },

    copy: {
      ...muiTheme.typography.body1,
      position: 'relative',
      paddingTop: muiTheme.spacing(2, cardMobileSidePadding),

      [muiTheme.breakpoints.up('md')]: {
        paddingTop: muiTheme.spacing(1),
      },
    },

    image: {
      '&': {
        height: 'calc(100% - 57px)',
      },
    },

    link: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
    },

    contentCategory: {
      '&.MuiTypography-root': {
        marginBottom: muiTheme.spacing(1),
        zIndex: 1,
        position: 'relative',
      },
    },

    innerContent: {
      display: '-webkit-box',
      '-webkit-line-clamp': 7,
      '-webkit-box-orient': 'vertical',
      textOverflow: 'ellipsis',
      height: '100%',
      overflow: 'hidden',
      position: 'relative',

      ...linearGradients,

      '&:after': {
        content: "''",
        position: 'absolute',
        height: muiTheme.spacing(3),
        left: 0,
        right: 0,
        bottom: 0,
      },
    },
    wrapper: {
      position: 'relative',
      width: '100%',
    },
  }),
  { name: 'GenContentCardSmall' },
);

export default useStyles;
